module.exports = __webpack_public_path__ + "assets/img/td6.54de515d.png";